<template>
  <alzata-splash>
    <router-view />
  </alzata-splash>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "App",
  components: {},
  methods: {
    ...mapActions("iam", ["getAuthenticationStatus"]),
    ...mapActions("splash", ["initialLoadComplete"]),
  },
  async mounted() {
    await this.getAuthenticationStatus();
    this.initialLoadComplete();
  },
};
</script>
